import { Component } from "@angular/core";

@Component({
  selector: "icon-aumento-pgu-infografia",
  templateUrl: "./aumento-pgu-infografia-orientacion-derecha.svg",
  styles: ["svg { display: block; width: 100%; height: auto; }"],
  standalone: true,
})
export class AumentoPguInfografiaComponent {}
